import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { catchError } from 'rxjs/operators';
import { ErrorService } from '../../error.service';
import { Observable } from 'rxjs';
import { throwError } from 'rxjs';
import { map, retry } from 'rxjs/operators';
import { ToastrService } from 'ngx-toastr';
import { NgZone } from '@angular/core';
import { ColumnChangeBO } from '../list/list.model';
import { getMappedCompanyBO, savePayorBO } from './payer.modal';
@Injectable({
    providedIn: 'root'
})
export class PayerService {
    httpOptions = {
        headers: new HttpHeaders({
            "Content-Type": "application/json",
        })
    };
    constructor(private http: HttpClient, public errorService: ErrorService, public toastrService: ToastrService, public zone: NgZone) { }
    SaveGroupPayor(save: savePayorBO): Observable<any> {
        let url = "api/Payer/SaveGroupPayor";
        return this.http.post(url, save, { observe: 'response', responseType: "text" },).pipe(
            map(data => data.body),
            catchError(this.errorService.handleError)
        )
    }
    DeleteGroupPayor(paramsData: URLSearchParams): Observable<any> {
        let url = "api/Payer/DeleteGroupPayor?";
        return this.http.delete(url + paramsData, { observe: 'response', responseType: "text" },).pipe(
            map(data => data.body),
            catchError(this.errorService.handleError)
        )
    }
    getLovTypes(paramsData: URLSearchParams): Observable<any> {
        let url = "api/Lov/GetLovDropDown?";
        return this.http.get<any>(url + paramsData, { observe: 'response' }).pipe(
          map(data => data.body),
          catchError(this.errorService.handleError)
        )
      }
   
    ////////===========================Column change func==================///
    getcolumwidth(): Observable<any> {

        let url = "api/ColumnChange/getwidth?";
        return this.http.get<any>(url, { observe: 'response' }).pipe(
            map(data => data.body),
            catchError(this.errorService.handleError)
        )
    }
    savecolumwidth(list: ColumnChangeBO): Observable<any> {

        let url = "api/ColumnChange/Savewidth?";
        return this.http.post<any>(url, list, { observe: 'response' }).pipe(
            map(data => data.body),
            catchError(this.errorService.handleError)
        )
    }
    getCompanyItem(paramsData: URLSearchParams): Observable<any> {
        
        let url = "api/PayorCompanyMap/GetPayorCompanyMappingList?";
        return this.http.get<any>(url + paramsData, { observe: 'response' }).pipe(
          map(data => data.body),
    
          catchError(this.errorService.handleError)
    
        )

       
      }
      deleteCompanyMapping(paramsData: URLSearchParams): Observable<any> {

        let url = "api/PayorCompanyMap/DeletePayorCompany?";
        return this.http.delete(url + paramsData, { observe: 'response' }).pipe(
          map(data => data.body),
    
          catchError(this.errorService.handleError)
    
        )
      }
      saveupdate(data: savePayorBO): Observable<number> {
        let url = "api/Payer/SaveGroupPayor";
        return this.http.post<number>(url, data, { observe: 'response' }).pipe(
          map(data => data.body),
        
        )
      }
      getcompany(): Observable<any> {

        let url = "api/PayorCompanyMap/getCompanyPayorList";
    
        return this.http.get<any>(url , { observe: 'response' }).pipe(
    
          map(data => data.body),
    
          catchError(this.errorService.handleError)
    
        )
    
      }

         //==============================get employee permission==========================================//
         getpermission(paramsData: URLSearchParams): Observable<any> {
          let url = "api/FunctionPermission/getfunctionpermissionemployee?";
          return this.http.get<any>(url + paramsData, { observe: 'response' }).pipe(
            map(data => data.body),
            catchError(this.errorService.handleError)
          )
        }
}
